import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { COPY } from '../copy';

/** An XDP form with no page images (`pageCount` null, or a 404 page list): downloads only. */
export function PreviewUnavailable() {
  return (
    <Box>
      <Typography variant="body1" sx={{ fontWeight: 600 }}>
        {COPY.previewUnavailableTitle}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {COPY.previewUnavailableBody}
      </Typography>
    </Box>
  );
}
